import { LoxSettings, defaultSettings } from "./types";

/* global Office */
const STORAGE_KEY = "lox24Settings";

export function loadSettings(): LoxSettings {
  const stored = Office.context.roamingSettings.get(STORAGE_KEY) as
    Partial<LoxSettings> | undefined;
  return { ...defaultSettings, ...(stored ?? {}) };
}

export function saveSettings(settings: LoxSettings): Promise<void> {
  Office.context.roamingSettings.set(STORAGE_KEY, settings);
  return persist();
}

export function clearSettings(): Promise<void> {
  Office.context.roamingSettings.remove(STORAGE_KEY);
  return persist();
}

function persist(): Promise<void> {
  return new Promise((resolve, reject) => {
    Office.context.roamingSettings.saveAsync((result) => {
      if (result.status === Office.AsyncResultStatus.Succeeded) {
        resolve();
      } else {
        reject(result.error);
      }
    });
  });
}
